import { Item } from "@components/SelectionList";

import { JobsConfigurationJob } from "./dtos";
import { JobList } from "./JobList";
import { useJobsFormOperations } from "./jobs.hooks";

interface JobsConfigurationFormProps {
  selectedJobId: string | undefined;
  setSelectedJobId: (value: string | undefined) => void;
}

export const JobsConfigurationForm: React.FC<JobsConfigurationFormProps> = ({
  selectedJobId,
  setSelectedJobId
}) => {
  const { jobs, addJob, deleteJob, updateJob } = useJobsFormOperations();

  const selectJob = (item: Item) => {
    const job = jobs.find(x => x.id === item.id);
    if (!job) return;

    setSelectedJobId(item.id);
  };

  const handleDelete = (job: JobsConfigurationJob) => {
    deleteJob(job);

    if (selectedJobId && selectedJobId === job.id) {
      setSelectedJobId(undefined);
    }
  };

  const selectedJob = jobs.find(x => x.id === selectedJobId);

  return (
    <JobList
      selectedJob={selectedJob}
      onSelectedItemChange={selectJob}
      onAddJob={addJob}
      onDeleteJob={handleDelete}
      onUpdateJob={updateJob}
    />
  );
};
